export default "<div> <div class=\"small-4 columns\" ng-repeat=\"kpi in kpis\"> <div> <label style=display:inline>{{kpi.efficiencyName}}:</label> {{kpi.efficiency}} </div> <div> <label style=display:inline>{{kpi.lossesName}}:</label> {{kpi.losses}} </div> <div ng-if=\"$index === 0\"> <label style=display:inline>Speed:</label> {{kpi.denominator.speed}} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/kpi.tpl.html
// module id = 434
// module chunks = 0